import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c1e2cca"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "manifold m-campaign-popup-container"
}
const _hoisted_2 = { class: "m-campaign-popup-header" }
const _hoisted_3 = { class: "m-campaign-popup-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_redeemable_tokens = _resolveComponent("m-redeemable-tokens")!
  const _component_m_redemption = _resolveComponent("m-redemption")!

  return (_ctx.state.loaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["m-campaign-popup", {
        show: _ctx.show,
        nav: _ctx.state.activeEligibleToken || _ctx.state.activeRedemption
      }])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
            }, "←"),
            _createElementVNode("h1", null, _toDisplayString(_ctx.state.campaignTitle) + _toDisplayString(_ctx.state.activeRedemption ? ` - ${_ctx.redemptionSuccessLabel}` : ''), 1),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
            }, "×")
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_m_redeemable_tokens),
            _createVNode(_component_m_redemption)
          ])
        ], 2)
      ]))
    : _createCommentVNode("", true)
}